<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import AuthorsTable from "./components/AuthorsTable.vue";

import HeaderHome from "./components/HeaderHome.vue";
// import ProjectsTable from "./components/ProjectsTable.vue";
const store = useStore();
onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});

const body = document.getElementsByTagName("body")[0];
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>

    <div class="container-fluid">
      <header-home></header-home>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <p class="text-uppercase text-sm">Información del mandato</p>
              <div class="row">
                <div class="col-12">
                  <authors-table />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <authors-table />
      </div>
    </div>
  </div> -->
</template>
